"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultType = void 0;
exports.ResultTypeFromJSON = ResultTypeFromJSON;
exports.ResultTypeFromJSONTyped = ResultTypeFromJSONTyped;
exports.ResultTypeToJSON = ResultTypeToJSON;
exports.ResultTypeToJSONTyped = ResultTypeToJSONTyped;
/**
 * Type of result
 * @export
 * @enum {string}
 */
var ResultType;
(function (ResultType) {
    ResultType["Found"] = "found";
    ResultType["Error"] = "error";
    ResultType["Redirect"] = "redirect";
    ResultType["Fallback"] = "fallback";
    ResultType["Success"] = "success";
})(ResultType || (exports.ResultType = ResultType = {}));
function ResultTypeFromJSON(json) {
    return ResultTypeFromJSONTyped(json, false);
}
function ResultTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ResultTypeToJSON(value) {
    return ResultTypeToJSONTyped(value, false);
}
function ResultTypeToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
